// PersistLogin.js
import React from 'react';
import usePersistLogin from './usePersistLogin';

const PersistLogin = () => {
  usePersistLogin();
  return null; // This component doesn't need to render anything
};

export default PersistLogin;